<script lang="ts">
  interface Props {
    user?: {
      name?: string
      nickname?: string
      organization?: string
      department?: string
      team?: string
      avatar_url?: string
    }
    privacy?: string
    size?: 'sm' | 'md' | 'lg'
    showAvatar?: boolean
  }

  let { user = {}, privacy = 'full_disclosure', size = 'md', showAvatar = true }: Props = $props()

  const avatarSizes = {
    sm: 'w-6 h-6',
    md: 'w-8 h-8',
    lg: 'w-10 h-10'
  }

  const textSizes = {
    sm: 'text-caption',
    md: 'text-body2',
    lg: 'text-body1'
  }

  function getDisplayInfo() {
    switch (privacy) {
      case 'full_disclosure':
        return {
          name: user?.name || '익명',
          subtitle: [user?.organization, user?.department, user?.team].filter(Boolean).join(' · ')
        }

      case 'company_only':
        return {
          name: user?.nickname || '익명 사용자',
          subtitle: [user?.organization, user?.department, user?.team].filter(Boolean).join(' · ')
        }

      case 'name_only':
        return {
          name: user?.name || '익명',
          subtitle: null
        }

      case 'anonymous':
      default:
        return {
          name: user?.nickname || '익명 사용자',
          subtitle: null
        }
    }
  }

  let displayInfo = $derived(getDisplayInfo())
</script>

<div class="flex items-center gap-2">
  {#if showAvatar}
    {#if user?.avatar_url}
      <img
        src={user.avatar_url}
        alt=""
        class="{avatarSizes[size]} rounded-full object-cover"
      />
    {:else}
      <div class="{avatarSizes[size]} bg-primary-50 dark:bg-primary/20 rounded-full flex items-center justify-center flex-shrink-0">
        <span class="text-primary {size === 'sm' ? 'text-xs' : 'text-sm'} font-medium">
          {displayInfo.name.charAt(0)}
        </span>
      </div>
    {/if}
  {/if}

  <div class="flex flex-col">
    <span class="{textSizes[size]} font-medium text-content">
      {displayInfo.name}
    </span>
    {#if displayInfo.subtitle}
      <span class="text-caption text-content-tertiary">
        {displayInfo.subtitle}
      </span>
    {/if}
  </div>
</div>
